import flatMap from 'array.prototype.flatmap'
import allSettled from 'promise.allsettled'
import promiseFinally from 'promise.prototype.finally'

allSettled.shim()
promiseFinally.shim()
flatMap.shim()
